export const FETCH_FEEDBACKS = 'FETCH_FEEDBACKS';
export const CREATE_FEEDBACK = 'CREATE_FEEDBACK';
export const UPDATE_FEEDBACK = 'UPDATE_FEEDBACK';
export const DELETE_FEEDBACK = 'DELETE_FEEDBACK';